<template>
  <div class="web-conversations">
    <div class="web-conversations__container">
      <div
        ref="webConversations"
        class="web-conversations__web-conversations"
        data-wcc-wrapper
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'WebConversationsWrapper',
  props: {
    webConversationsConfigId: {
      type: String,
      default: '',
    },
  },
  computed: {
    wcc() {
      if (!window.wcc[this.webConversationsConfigId]) {
        throw new Error('Web Conversations not (yet) initialized!');
      }
      return window.wcc[this.webConversationsConfigId];
    },
  },
  mounted() {
    this.initWebConversations();
    setTimeout(() => this.shadowDomStyling(), 2500);
  },
  methods: {
    initWebConversations() {
      (function(w, d, t, c) {
        w.wcc = w.wcc || {};
        w.wcc[c] = [...(w.wcc[c] || [])];
        var g = d.createElement(t),
          s = d.getElementsByTagName(t)[0];
        g.src = '//projects.elitechnology.com/jsprojects/wcc/init.js?v=' + +new Date();
        g.async = true;
        s.parentNode.insertBefore(g, s);
      })(window, document, 'script', this.webConversationsConfigId);
    },
    askQuestion(questionString) {
      this.wcc.push(['ask', { data: { userInput: questionString }, metadata: {} }]);
    },
    shadowDomStyling() {
      let sheet = new CSSStyleSheet();
      sheet.replaceSync(`
        cxco-root {
          --cxco-primary-h: 134;
          --cxco-primary-s: 100%;
          --cxco-primary-l: 40%;
        }

        cxco-c-field,
        .cxco-c-field {
          display: none;
        }

        .cxco-o-inline {
          border: 0;
        }

        .cxco-o-inline[min-width="768px"] .cxco-o-chat {
            border-right: 0;
        }

        .cxco-o-chat {
          backdrop-filter: none;
        }

        .cxco-c-bubble {
          border-radius: 1.25rem;
          border-top-left-radius: .25rem;
        }

        .cxco-c-bubble.cxco-c-bubble--inverted {
          border-radius: 1.25rem;
          border-top-left-radius: 1.25rem;
          border-top-right-radius: .25rem !important;
        }

        .cxco-c-conversation {
          position: relative;
          width: 100%;
          height: 100%;
          overflow: auto;
        }

        .cxco-c-conversation::-webkit-scrollbar {
          border-radius: .25rem;
          background-color: #fbf3d9;
          height: 0px;
        }

        .cxco-c-conversation::-webkit-scrollbar-track {
          background-color: #fbf3d9;
        }

        .cxco-c-conversation::-webkit-scrollbar-thumb {
          background-color: #ef575d;
        }
      `);

      // Find first data-wcc-wrapper (multiple items can be added to the footer)
      // Select second child. First child = <style>. Second one is the generated wcc-tag where additional shadow styles are needed
      const element = document.querySelectorAll('[data-wcc-wrapper]')[0]?.children[1];

      if (!element) {
        return;
      }

      element.shadowRoot.adoptedStyleSheets = [sheet];
    },
  },
};
</script>

<style lang="postcss">
.web-conversations {
  height: 100%;

  &__container {
    position: relative;
    height: 100%;
  }

  &__web-conversations {
    @apply z-0;
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .cxco-root,
  .cxco-c-bubble,
  wcc-611b7405-caa1-40a2-a5df-95347032523a {
    --cxco-c-bubble--inverted--bg-color-start: blue;
    --cxco-c-bubble--inverted--bg-color-end: blue;
  }
}
</style>
